import React, {Fragment} from "react";
import styled from "styled-components";
import {range} from "lodash";
import {media} from "assets/css/media";
import {TooltipRenderProps} from "react-joyride";
import {PureButton} from "components";
import {ReactComponent as Chevron} from "assets/images/icons/arrow.svg";
import close from "assets/images/icons/closeWhite.svg";

const CloseButton = styled(PureButton)`
	position: absolute;
	top: 0;
	right: 0;
	cursor: pointer;
	width: 40px;
	height: 40px;
	img {
		vertical-align: middle;
	}
`;

const ArrowWrapper = styled(PureButton)`
	height: 40px;
	width: 40px;
	display: flex;
	align-items: center;
	justify-content: center;

	&:disabled {
		cursor: default;
		svg {
			fill: #fff;
		}
	}
`;

const TourArrow = styled.div`
	height: 28px;
	width: 28px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;

	svg {
		fill: #00cfb7;
	}

	&.next svg {
		transform: rotateZ(180deg);
	}
`;

const TooltipBody = styled.div`
	box-sizing: border-box;
	max-width: 660px;
	position: relative;
	padding: 30px 20px;
	color: #ffffff;
	background: linear-gradient(227.93deg, #873eb4 0%, #873eb4 25%, #550065 100%);
	text-align: center;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
	border-radius: 10px;

	@media screen and (max-width: ${media.mobile}) {
		max-width: 340px;
		padding: 22px 32px 32px;
	}
`;

const TooltipTitle = styled.h2`
	margin-bottom: 16px;
	color: #ae9142;
	text-align: left;
	font-family: Qatar2022;
	font-size: 18px;
	line-height: 140%;

	@media screen and (max-width: ${media.mobile}) {
		font-size: 20px;
	}
`;

const TooltipMessage = styled.p`
	font-family: Graphik;
	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	line-height: 160%;
	margin-bottom: 16px;
	text-align: left;

	@media screen and (max-width: ${media.mobile}) {
		font-size: 16px;
		line-height: 24px;
	}
`;

const TooltipControls = styled.div`
	width: 200px;
	margin: auto;
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

const TooltipDots = styled.div`
	width: 150px;
	display: flex;
	justify-content: space-between;
	gap: 20px;
	margin: 0 20px;
`;

interface ITooltipDotProps {
	isActive: boolean;
}

const TooltipDot = styled.span<ITooltipDotProps>`
	box-sizing: border-box;
	height: 10px;
	width: 10px;
	border-radius: 50%;
	background: ${({theme, isActive}) => (isActive ? "#00CFB7" : "#E5E5E5")};
`;

interface ITooltipContentProps {
	title: string;
	message: string;
}

export const TooltipContent: React.FC<ITooltipContentProps> = ({title, message}) => (
	<Fragment>
		<TooltipTitle>{title}</TooltipTitle>
		<TooltipMessage>{message}</TooltipMessage>
	</Fragment>
);

export const TourTooltip: React.FC<TooltipRenderProps> = ({
	// continuous,
	index,
	isLastStep,
	size,
	step,
	backProps,
	closeProps,
	skipProps,
	primaryProps,
	tooltipProps,
}) => {
	const dots = range(0, size).map((value, i) => {
		const isActive = index === i;
		return <TooltipDot key={value} isActive={isActive} />;
	});

	return (
		<TooltipBody {...tooltipProps}>
			<CloseButton {...skipProps}>
				<img src={close} alt="Close" />
			</CloseButton>
			{step.content}
			<TooltipControls>
				<ArrowWrapper {...backProps} disabled={index <= 0}>
					<TourArrow>
						<Chevron height="16" width="16" />
					</TourArrow>
				</ArrowWrapper>
				<TooltipDots>{dots}</TooltipDots>
				<ArrowWrapper {...primaryProps} disabled={isLastStep}>
					<TourArrow className="next">
						<Chevron height="16" width="16" />
					</TourArrow>
				</ArrowWrapper>
			</TooltipControls>
		</TooltipBody>
	);
};
